var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modern-bar-chart',{attrs:{"title":_vm.title,"series":_vm.series,"categories":_vm.categories,"colors":_vm.chartColors,"height":350,"stacked":true,"horizontal":false,"display-mode":_vm.displayMode,"percent-basis":"category"}})}
var staticRenderFns = []

export { render, staticRenderFns }